package com.milta.core.localization.translations.it

import com.milta.core.localization.UnlocatedDeliveryStrings

internal val UnlocatedDelivery = UnlocatedDeliveryStrings(
    warningTitleSingular = "1 indirizzo non localizzato",
    warningTitlePlural = "%d indirizzi non localizzati",
    warningMessage = "Queste consegne non sono state posizionate sulla mappa. Correggi il loro indirizzo o continua: verranno messe alla fine del giro.",
    fixAction = "Correggi",
    continueWithoutAction = "Continua senza di esse",
    unplacedStopsSingular = "1 fermata non posizionata, alla fine del giro",
    unplacedStopsPlural = "%d fermate non posizionate, alla fine del giro",
    fixAddressAction = "Correggi l'indirizzo",
    unlocatedBadge = "Non localizzato",
)
